import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const ContactsApi = createApi({
  reducerPath: "ContactsApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["CONTACTSAPI"],
  endpoints: (build) => ({
    getContacts: build.query({
      query: ({ page, search = "", tags = "", limit = 10 }) => ({
        url: `/contacts?page=${page}&search=${search}&tags=${tags}&limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CONTACTSAPI"],
    }),

    getContactById: build.query({
      query: ({ id }) => ({
        url: `/contacts/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CONTACTSAPI"],
    }),

    getContactsByTag: build.query({
      query: ({ tag, page = 1, limit = 10 }) => ({
        url: `/contacts/tags/${tag}?page=${page}&limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CONTACTSAPI"],
    }),

    getAllTags: build.query({
      query: () => ({
        url: `/contacts/tags`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CONTACTSAPI"],
    }),

    addContact: build.mutation({
      query: ({ data }) => ({
        url: `/contacts`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["CONTACTSAPI"],
    }),

    editContact: build.mutation({
      query: ({ id, data }) => ({
        url: `/contacts/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["CONTACTSAPI"],
    }),

    updateContact: build.mutation({
      query: ({ id, data }) => ({
        url: `/contacts/${id}`,
        method: "PATCH",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["CONTACTSAPI"],
    }),

    deleteContact: build.mutation({
      query: ({ id }) => ({
        url: `/contacts/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["CONTACTSAPI"],
    }),

    bulkImportContacts: build.mutation({
      query: ({ contacts }) => ({
        url: `/contacts/bulk-import`,
        method: "POST",
        body: { contacts },
        headers: {},
      }),
      invalidatesTags: ["CONTACTSAPI"],
    }),
  }),
});

export const {
  useGetContactsQuery,
  useGetContactByIdQuery,
  useGetContactsByTagQuery,
  useGetAllTagsQuery,
  useAddContactMutation,
  useEditContactMutation,
  useUpdateContactMutation,
  useDeleteContactMutation,
  useBulkImportContactsMutation,
  useLazyGetContactByIdQuery,
} = ContactsApi;
